import dayjs from "dayjs";
import type { TableColumnType } from "ant-design-vue";

export const progressColumns: TableColumnType[] = [
  {
    title: "Usuario",
    dataIndex: ["user", "fullname"],
    ellipsis: true,
  },
  {
    title: "N° documento de contacto",
    dataIndex: ["client", "document_number"],
  },
  {
    title: "Producto",
    dataIndex: ["account", "code"],
    customRender: ({ text }) => text || "-",
  },
  {
    title: "Fecha de PDP",
    dataIndex: "date",
    customRender: ({ text }) => dayjs(text).format("DD/MM/YYYY"),
  },
  {
    title: "Monto de PDP",
    dataIndex: "total_amount",
  },
  {
    title: "Total de gestiones",
    dataIndex: "total_pdp",
  },
  {
    title: "Contacto Directo",
    dataIndex: ["managements", "cd"],
  },
  {
    title: "Contacto Indirecto",
    dataIndex: ["managements", "ci"],
  },
  {
    title: "No contacto",
    dataIndex: ["managements", "nc"],
  },
];
